import { useCities } from "@/modules/cities/components/hooks/use-cities.hook";
import { useMemo } from "react";

export const useCityMap = () => {
  const { cities, loading, error } = useCities();

  const { cityMap, cityList } = useMemo(() => {
    const cityMap = new Map<string, string>();
    const cityList: { value: string; label: string }[] = [];

    if (!cities) {
      return { cityMap, cityList };
    }
    for (const city of cities) {
      cityMap.set(city.id, city.name);
      cityList.push({ value: city.id, label: city.name });
    }

    return { cityMap, cityList };
  }, [cities]);

  return { cityMap, cityList, loading, error };
};
